import React, { useState, useCallback } from 'react';
import AlterDomainBR from '@/media/onboarding/temporary-domain-br.png';
import AlterDomainES from '@/media/onboarding/temporary-domain-es.webp';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import { isBRServer } from '@/utils/Validators/validation';
import * as Styles from './SiteAlreadyExists.styles';
import { IconCheck, IconWarning, Checkbox } from 'gatorcomponents';

const SiteAlreadyExists = ({
  locales, buttonsProps, onContinue, isLoading,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const stepProps = useCallback(() => {
    const customButtonsProps = {
      ...buttonsProps,
      rightButton: {
        ...buttonsProps.rightButton,
        onClick: onContinue,
        disabled: isLoading || !isChecked,
        loading: isLoading,
      },
    };

    return {
      imageSrc: isBRServer ? AlterDomainBR : AlterDomainES,
      buttonsProps: customButtonsProps,
    };
  }, [buttonsProps, onContinue, isLoading, isChecked]);

  return (
    <GenericStep
      {...stepProps()}
    >
      <Styles.Wrapper>
        <Styles.TitleWrapper>
          <IconWarning
            color="attentionExtraDark"
            size="lg"
          />
          <Styles.Title>{locales.title}</Styles.Title>
        </Styles.TitleWrapper>
        <Styles.Description>{locales.description()}</Styles.Description>
        <Styles.BulletPointsWrapper>
          <Styles.BulletPointsTitle>{locales.bulletPoints.title}</Styles.BulletPointsTitle>
          {locales.bulletPoints.list.map(item => (
            <Styles.BulletPoint key={item}>
              <IconCheck color="primaryMedium" />
              {item}
            </Styles.BulletPoint>
          ))}
        </Styles.BulletPointsWrapper>

        <Styles.CheckboxLabel
          htmlFor="#check-agreement"
          data-testid="check-agreement-label"
          onClick={() => setIsChecked(!isChecked)}
        >
          <Checkbox checked={isChecked} id="check-agreement" />
          {locales.checkboxLabel}
        </Styles.CheckboxLabel>
      </Styles.Wrapper>
    </GenericStep>
  );
};

export default SiteAlreadyExists;
